import isEmpty from 'lodash/isEmpty';
import dateUtils from '@utils/dateUtils';

export default function normalize(data) {
    let ret = {};

    ret.id = data.rateId;
    ret.currency = data.currency;
    ret.inventory = data.inventory;
    ret.amountBeforeTax = data.amountBeforeTax ? [...data.amountBeforeTax] : [0];
    ret.amountAfterTax = data.amountAfterTax ? [...data.amountAfterTax] : ret.amountBeforeTax;
    ret.totalPrice = data.totalPrice
        ? data.totalPrice
        : data.amountAfterTax
          ? [...data.amountAfterTax]
          : ret.amountBeforeTax;
    ret.mealPlan = data.mealPlan;
    ret.fees = data.fees.map((item) => normalizeFee(item));
    ret.type = data.rateType || null;
    ret.paymentType = data.paymentType || null;
    ret.cancellationPolicies = data.cancellationPolicies
        ? data.cancellationPolicies.map((item) => normalizeCancellationPolicy(item))
        : null;
    ret.netAmount = data.netAmount || 0;
    ret.totals = {
        basePrice: ret.amountBeforeTax.reduce((item, acc) => acc + item, 0),
        netPrice: ret.netAmount, //price from provider
    };
    ret.packageOffer = !isEmpty(data.packageOffer)
        ? normalizePackageOffer(data.packageOffer)
        : null;

    return ret;
}

function normalizeFee(data = {}) {
    return {
        dateRange: {
            startDate: data.dateRange.startDate,
            endDate: data.dateRange.endDate,
        },
        fee: {
            name: data.fee.name,
            type: data.fee.type,
            typeIncluded: data.fee.included,
            amount: data.fee.amount,
            amountType: data.fee.amountType,
            chargeType: data.fee.chargeType,
            effectivePerson: data.fee.effectivePerson,
        },
    };
}

function normalizePackageOffer(data) {
    return {
        basePrice: data.basePrice,
        id: data.id,
        ticketTypeId: data.ticketTypeId,
        inventory: data.inventory,
    };
}

function normalizeCancellationPolicy(data) {
    return {
        amount: data.amount,
        fromAt: data.from ? dateUtils.parseDateString(data.from) : null,
        percent: data.percent,
        numberOfNights: data.numberOfNights,
        _originalFromAt: data.from,
    };
}
